import antd_ar from "antd/lib/locale/ar_EG";
import antd_en from "antd/lib/locale/en_US";
import antd_es from "antd/lib/locale/es_ES";
import antd_fr from "antd/lib/locale/fr_FR";
import antd_hi from "antd/lib/locale/hi_IN";
import antd_id from "antd/lib/locale/id_ID";
import antd_pt from "antd/lib/locale/pt_PT";
import ar from "./ar";
import en from "./en";
import es from "./es";
import fr from "./fr";
import hi from "./hi";
import id from "./id";
import pt from "./pt";

export const LOCALES = {
  ENGLISH: "en",
  EGYPTIAN: "ar",
  INDONESIAN: "id",
  FRANCE: "fr",
  HINDI: "hi",
  SPANISH: "es",
  Portuguese: "pt",
};

const locales = {
  [LOCALES.ENGLISH]: en,
  [LOCALES.EGYPTIAN]: ar,
  [LOCALES.INDONESIAN]: id,
  [LOCALES.HINDI]: hi,
  [LOCALES.FRANCE]: fr,
  [LOCALES.SPANISH]: es,
  [LOCALES.Portuguese]: pt,
};

export const antdLocalesMap = {
  [LOCALES.ENGLISH]: antd_en,
  [LOCALES.EGYPTIAN]: antd_ar,
  [LOCALES.INDONESIAN]: antd_id,
  [LOCALES.HINDI]: antd_hi,
  [LOCALES.FRANCE]: antd_fr,
  [LOCALES.SPANISH]: antd_es,
  [LOCALES.Portuguese]: antd_pt,
};
export default locales;
